export default "__VITE_ASSET__C8rBc30b__"